



















































import {Component, Mixins} from 'vue-property-decorator';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin'
import { isDoneClaim } from './validations';

// 취소, 반품 상품 금액 상세 (B)
@Component({
  computed: {
    hasNoCoupons() { // TODO: 네이밍
      return !this.productAmt.productCoupons || this.productAmt.productCoupons.length === 0
    },
    isDoneClaim() {
      return isDoneClaim(this.claimNoResponseData.claimStatusType)
    },
  }
})
export default class ProductAmountDetail extends Mixins(AmountMixin){
  created(){
    this.setProductAmt()
  }

  private setProductAmt(){
    const {standardAmt, immediateDiscountAmt, additionalDiscountAmt, freeGiftDiscountAmt } = this.amounts.refund.order
    this.productAmt.standardAmt = standardAmt
    this.productAmt.immediateDiscountAmt = immediateDiscountAmt
    this.productAmt.additionalDiscountAmt = additionalDiscountAmt
    this.productAmt.productCouponDiscountAmt = this.amounts.refund.coupon.productCouponDiscountAmt
    this.productAmt.freeGiftDiscountAmt = freeGiftDiscountAmt;
    
    const coupon = this.claimNoResponseData.claimData.coupon
    this.productAmt.productCoupons = coupon ? coupon.productCoupons : []
  }


  // 취소상품 금액상세 row, https://nhnent.dooray.com/files/2783204365893155685
  private productAmt = {
    standardAmt: 0, // 상품금액
    immediateDiscountAmt: 0, // 즉시할인금액
    additionalDiscountAmt: 0, // 추가할인(-)
    productCouponDiscountAmt: 0, // 상품쿠폰 재계산(-)
    freeGiftDiscountAmt: 0, // 사은품(-)
    productCoupons: [],

    get productTotalAmt(){ // 상품합계(+)
      return this.standardAmt - this.immediateDiscountAmt
    },

    get totalAmt(){ // 취소 금액합계 a
      return this.productTotalAmt - this.additionalDiscountAmt - this.productCouponDiscountAmt - this.freeGiftDiscountAmt
    }
  }
}
